import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eb/i18n';
import classNames from 'classnames';
import { AlertChunky } from '@eb/eds-iconography';

import NotificationScreen from '../../components/NotificationScreen';
import ModalMessage from '../../components/ModalMessage';

import { SOFT_ACCOUNT_EMAIL_STATUSES } from '../../constants/status';

import './SoftAccountStatusContent.scss';

/**
 * List of urls that will lead to this page:
 * * BASE_URL/SOFT_ACCOUNT_STATUS_PATH
 */
export default class SoftAccountStatusContent extends React.Component {
    static propTypes = {
        email: PropTypes.string,
        softAccountEmailStatus: PropTypes.string,
    };

    render() {
        const { email, softAccountEmailStatus } = this.props;
        const componentClasses = classNames(
            'eds-l-mar-vert-14',
            'soft-account-status-content',
        );

        let headerText = gettext('Never lose your tickets');

        let subtitleText = (
            <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: gettext(
                        'We sent a link to <strong>%(email)s</strong> to add a password to your account.',
                        {
                            email,
                        },
                    ).toString(),
                }}
            />
        );
        let softComponent = (
            <ModalMessage
                headerText={headerText}
                subtitleText={subtitleText}
                email={email}
            />
        );

        //Need to conditionally check if the email is present and update copy accordingly
        //in case the user refreshes the notification page and we lose the email from state.

        if (softAccountEmailStatus === SOFT_ACCOUNT_EMAIL_STATUSES.failed) {
            headerText = gettext('There has been an error');
            subtitleText = gettext('Please try again later');
            softComponent = (
                <NotificationScreen
                    iconColor="ui-700"
                    iconType={<AlertChunky />}
                    headerText={headerText}
                    subtitleText={subtitleText}
                    usesNewStyles={true}
                />
            );
        }

        return <div className={componentClasses}>{softComponent}</div>;
    }
}
